import { ACTION_TYPES } from '../constants/actions';

export const initialState = {
  searchNumbers: {
    numbers: [],
    signature: undefined,
    loading: false,
    error: false
  },
  reserveResource: {
    success: true,
    loading: false,
    error: false
  }
};

const ngnisReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_SEARCH_NUMBERS':
      return {
        ...state,
        searchNumbers: {
          ...initialState.searchNumbers
        }
      };
    case 'SET_SEARCH_NUMBERS_SUCCESS':
      return {
        ...state,
        searchNumbers: {
          ...state.searchNumbers,
          numbers: action.value.numbers,
          signature: action.value.signature,
          loading: false,
          error: false
        }
      };
    case 'SET_SEARCH_NUMBERS_LOADING':
      return {
        ...state,
        searchNumbers: {
          ...state.searchNumbers,
          numbers: [],
          signature: undefined,
          loading: action.value,
          error: false
        }
      };
    case 'SET_SEARCH_NUMBERS_ERROR':
      return {
        ...state,
        searchNumbers: {
          ...state.searchNumbers,
          numbers: [],
          signature: undefined,
          loading: false,
          error: true
        }
      };

    case 'VALIDATE_NGNIS_ADDRESS_LOADING': {
      return {
        ...state,
        loading: true
      };
    }

    case 'VALIDATE_NGNIS_ADDRESS_SUCCESS': {
      return {
        ...state,
        loading: false,
        validateAddress: action.value
      };
    }

    case 'VALIDATE_NGNIS_ADDRESS_ERROR': {
      return {
        ...state,
        loading: false,
        error: true,
        validateAddress: action.value
      };
    }

    case ACTION_TYPES.DELIVERY.UPDATE_ADDRESS_INFO: {
      return {
        ...state,
        validateAddress: undefined
      };
    }

    default:
      return state;
  }
};

export default ngnisReducer;
